<div class="align text-center">
  <h5>Logging you out...</h5>
</div>
